<template>
    <vessels-data-table />
</template>

<script>

import VesselsDataTable from '@/components/VesselsDataTable';


export default {
    name: 'VesselsManagement',
    components: {
        VesselsDataTable
    }
};
</script>